import JumpCloudIcon from 'components/core/icons/jumpcloud.svg'
import Image from 'components/core/image'
import React from 'react'

const JumpCloud = (): React.ReactElement => {
    return <Image src={JumpCloudIcon.src} height={24} width={24} />
}

export default JumpCloud
